export default "__VITE_ASSET__DDtbTyyo__"